<template>
	<div class="fans-detail">
		<!-- 基础信息 -->
		<div class="basic-info">
			<el-card class="info-card" shadow="never">
				<div slot="header" class="card-header">
					<span>基础信息</span>
				</div>
				<div class="user-basic">
					<div class="avatar-section">
						<img :src="fanInfo.avatar" alt="头像" class="avatar" />
					</div>
					<div class="info-section">
						<div class="info-row">
							<label>昵称：</label>
							<span>{{ fanInfo.nickname || '未设置' }}</span>
						</div>
						<div class="info-row">
							<label>手机号：</label>
							<span>{{ fanInfo.mobile }}</span>
						</div>
						<div class="info-row">
							<label>微信号：</label>
							<span>{{ fanInfo.wechat_id || '未设置' }}</span>
						</div>
						<div class="info-row">
							<label>邀请码：</label>
							<span>{{ fanInfo.invite_code }}</span>
						</div>
						<div class="info-row">
							<label>等级：</label>
							<div class="level-info">
								<el-tooltip :content="fanInfo.level_name" placement="top">
									<img :src="fanInfo.level_icon" alt="等级" class="level-icon" />
								</el-tooltip>
								<span>{{ fanInfo.level_name }}</span>
							</div>
						</div>
						<div class="info-row">
							<label>状态：</label>
							<el-tooltip content="有过手机号绑定、淘宝备案、下单、提现其中任一行为的用户" placement="top" v-if="fanInfo.is_effective">
								<el-tag type="info'" size="small">有效</el-tag>
							</el-tooltip>
						</div>
						<div class="info-row">
							<label>加入时间：</label>
							<span>{{ formatTime(fanInfo.jointime) }}</span>
						</div>
						<div class="info-row">
							<label>最近登录：</label>
							<span>{{ formatTime(fanInfo.logintime) }}</span>
						</div>
					</div>
				</div>
			</el-card>
		</div>

		<!-- 数据概况 -->
		<div class="income-overview">
			<el-card class="income-card" shadow="never" v-loading="incomeLoading">
				<div slot="header" class="card-header">
					<span>数据概况</span>
				</div>
				<div class="income-stats">
					<div class="income-item">
						<div class="income-value today">{{ fanInfo.fans }}</div>
						<div class="income-label">团队成员</div>
					</div>
					<div class="income-item">
						<div class="income-value today">{{ total }}</div>
						<div class="income-label">直属成员</div>
					</div>
					<div class="income-item">
						<div class="income-value last">{{ fanInfo.order_num }}</div>
						<div class="income-label">总订单数</div>
					</div>
					<div class="income-item">
						<div class="income-value month">￥{{ fanInfo.credit_total }}</div>
						<div class="income-label">累计收益</div>
					</div>
					<div class="income-item">
						<div class="income-value month">¥{{ incomeData.today_commission || 0 }}</div>
						<div class="income-label">今日预估</div>
					</div>
					<div class="income-item">
						<div class="income-value month">¥{{ incomeData.predict_income || 0 }}</div>
						<div class="income-label">本月预估</div>
					</div>
					<div class="income-item">
						<div class="income-value month">¥{{ incomeData.last_income || 0 }}</div>
						<div class="income-label">上月结算</div>
					</div>
				</div>
			</el-card>
		</div>

		<!-- 下级成员列表 -->
		<div class="sub-fans">
			<el-card class="sub-fans-card" shadow="never" v-loading="teamLoading">
				<div slot="header" class="card-header">
					<span>直属成员({{ total }}人)</span>
					<span class="total-count">平台仅支持展示直属成员</span>
				</div>

				<div class="sub-fans-list">
					<el-table 
						:data="subFansList" 
						style="width: 100%"
						stripe
					>
						<el-table-column label="用户信息">
							<template slot-scope="scope">
								<div class="user-info">
									<img :src="scope.row.avatar" alt="头像" class="mini-avatar" />
									<div class="info">
										<div class="nickname">{{ scope.row.nickname || '未设置昵称' }}</div>
										<div class="mobile">{{ scope.row.mobile }}</div>
									</div>
								</div>
							</template>
						</el-table-column>

						<el-table-column label="等级" width="120" align="center">
							<template slot-scope="scope">
								<el-tooltip :content="scope.row.type" placement="top">
									<img :src="scope.row.level_icon" alt="等级" class="mini-level-icon" />
								</el-tooltip>
							</template>
						</el-table-column>

						<el-table-column prop="invite_code" label="邀请码" width="100" align="center"></el-table-column>

						<el-table-column prop="order_num" label="订单数" width="80" align="center">
							<template slot-scope="scope">
								<span class="amount color1">{{ scope.row.order_num }}</span>
							</template>
						</el-table-column>

						<el-table-column label="今日预估" width="100" align="center">
							<template slot-scope="scope">
								<span class="amount">¥{{ scope.row.today_commission || 0 }}</span>
							</template>
						</el-table-column>

						<el-table-column label="本月预估" width="100" align="center">
							<template slot-scope="scope">
								<span class="amount">¥{{ scope.row.predict_income || 0 }}</span>
							</template>
						</el-table-column>

						<el-table-column label="上月结算" width="100" align="center">
							<template slot-scope="scope">
								<span class="amount">¥{{ scope.row.last_income || 0 }}</span>
							</template>
						</el-table-column>

						<el-table-column label="注册时间" width="120" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.createtime }}</span>
							</template>
						</el-table-column>

						<el-table-column label="最近登录" width="180" align="center">
							<template slot-scope="scope">
								<span>{{ formatTime(scope.row.logintime) }}</span>
							</template>
						</el-table-column>

					</el-table>
					<!-- 分页 -->
					<div class="pagination-wrapper" v-if="total > 10">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="pagination.page"
							:page-sizes="[10, 20, 50]"
							:page-size="pagination.pagesize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total"
						></el-pagination>
					</div>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import { getFansIncome, getFansTeam } from '@/api/public'
import { formatTime } from '@/utils/timeTransfer'

export default {
	name: 'FansDetail',
	props: {
		fanInfo: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			incomeLoading: false,
			teamLoading: false,
			incomeData: {
				today_commission: 0,
				predict_income: 0,
				last_income: 0
			},
			// 分页
			pagination: {
				page: 1,
				pagesize: 10
			},
			subFansList: [],
			total: 0
		}
	},
	mounted() {
		this.fetchIncomeData()
		this.fetchTeamData()
	},
	methods: {
		// 获取收益数据
		async fetchIncomeData() {
			this.incomeLoading = true
			try {
				const response = await getFansIncome({ uid: this.fanInfo.id })
				if (response && response.code === 1) {
					this.incomeData = response.data
				}
			} catch (error) {
				console.error('获取收益数据失败:', error)
				this.$message.error('获取收益数据失败')
			} finally {
				this.incomeLoading = false
			}
		},

		// 获取团队数据
		async fetchTeamData() {
			this.teamLoading = true
			try {
				const response = await getFansTeam({ id: this.fanInfo.id,page: this.pagination.page,pagesize: this.pagination.pagesize, pcweb: 1 })
				if (response && response.code === 1) {
					this.subFansList = response.data.list || []
					this.total = response.data.total || 0
				}
			} catch (error) {
				console.error('获取团队数据失败:', error)
				this.$message.error('获取团队数据失败')
			} finally {
				this.teamLoading = false
			}
		},

		// 格式化时间
		formatTime(timestamp) {
			return formatTime(timestamp * 1000)
		},

		// 分页大小改变
		handleSizeChange(val) {
			this.pagination.pagesize = val
			this.pagination.page = 1
			this.fetchTeamData()
		},

		// 当前页改变
		handleCurrentChange(val) {
			this.pagination.page = val
			this.fetchTeamData()
		}
	}
}
</script>

<style lang="scss" scoped>
.fans-detail {
	padding: 20px;
	height: 100%;
	overflow-y: auto;
}

.basic-info {
	margin-bottom: 20px;
	
	.info-card {
		.card-header {
			font-size: 16px;
			font-weight: 600;
			color: #303133;
		}
		
		.user-basic {
			display: flex;
			align-items: center;
			.avatar-section {
				margin-right: 20px;
				
				.avatar {
					width: 80px;
					height: 80px;
					border-radius: 50%;
					object-fit: cover;
				}
			}
			
			.info-section {
				display: flex;
				flex-wrap: wrap;
				flex: 1;
				
				.info-row {
					display: flex;
					align-items: center;
					margin-bottom: 12px;
					width: 50%;
					
					label {
						width: 80px;
						color: #111111;
						font-size: 14px;
						font-weight: 600;
					}
					
					span {
						color: #303133;
						font-size: 14px;
					}
					
					.level-info {
						display: flex;
						align-items: center;
						
						.level-icon {
							height: 20px;
							margin-right: 6px;
						}
					}
				}
			}
		}
	}
}

.income-overview {
	margin-bottom: 20px;
	
	.income-card {
		.card-header {
			font-size: 16px;
			font-weight: 600;
			color: #303133;
		}
		
		.income-stats {
			display: flex;
			justify-content: space-around;
			
			.income-item {
				text-align: center;
				
				.income-value {
					font-size: 24px;
					font-weight: 700;
					margin-bottom: 8px;
					font-family: 'customFont';
					&.today {
						color: #111111;
					}
					
					&.month {
						color: #e2231a;
					}
					
					&.last {
						color: #E6A23C;
					}
				}
				
				.income-label {
					color: #909399;
					font-size: 14px;
				}
			}
		}
	}
}

.sub-fans {
	.sub-fans-card {
		.card-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 16px;
			font-weight: 600;
			color: #303133;
			
			.total-count {
				color: #909399;
				font-size: 14px;
				font-weight: normal;
			}
		}
		
		.sub-fans-list {
			::v-deep .el-table {
				.user-info {
					display: flex;
					align-items: center;
					
					.mini-avatar {
						width: 40px;
						height: 40px;
						border-radius: 50%;
						margin-right: 8px;
						object-fit: cover;
					}
					
					.info {
						.nickname {
							font-size: 12px;
							font-weight: 500;
							color: #303133;
							margin-bottom: 2px;
						}
						
						.mobile {
							font-size: 12px;
							color: #909399;
						}
					}
				}
				
				.mini-level-icon {
					height: 20px;
				}
				
				.amount {
					color: #e2231a;
					font-size: 18px;
					font-family: 'customFont';
				}
				.color1 {
					color: #111111;
				}
			}
		}
	}
	.pagination-wrapper {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
}

@media (max-width: 768px) {
	.user-basic {
		flex-direction: column !important;
		
		.avatar-section {
			margin-bottom: 16px;
			text-align: center;
		}
		
		.info-section {
			.info-row {
				label {
					width: 100px;
				}
			}
		}
	}
	
	.income-stats {
		flex-direction: column !important;
		
		.income-item {
			margin-bottom: 16px;
		}
	}
}
</style> 